import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

export type BlackListReason = {
  id: number;
  description: string;
};

type GetMerchantBlackListReasonsResponse = BaseResponse<BlackListReason[]>;

async function getMerchantBlackListReasons(): Promise<GetMerchantBlackListReasonsResponse> {
  try {
    const response = await axiosInstance.get("/Merchant/GetMerchantBlackListReasons");
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantBlackListReasons() {
  return useQuery<GetMerchantBlackListReasonsResponse, Error>(
    [QueryKeys.GetMerchantBlackListReasons],
    getMerchantBlackListReasons
  );
}